import { HttpInterceptorFn } from '@angular/common/http';

/** Bypass ngrok browser warning page for programmatic API calls. */
export const ngrokInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.includes('ngrok-free.app') && !req.url.includes('ngrok-free.dev')) {
    return next(req);
  }

  return next(
    req.clone({
      setHeaders: {
        'ngrok-skip-browser-warning': 'true',
      },
    })
  );
};
